import React from 'react';
import './ProfilCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import userNeutralIcon from '../content/functionalpagelogin/images/user_neutral.png';

const ProfilCard = ({ userData, onProfileSave, username, onUsernameChange }) => {
  return (
    <div className='profil-card'>
      {/* Titlu vizibil pe toate rezolutiile */}
      <h4 className='profil-card__desktop-title'>Profil</h4>
      {/* Titlu vizibil doar pe mobil */}
    
      <div className='profil-card__picture-section'>
        <div className='profil-card__picture-wrapper'>
          <div className='profil-card__picture-container'>
            <img
              src={userData?.profile_picture || userNeutralIcon}
              alt="Profile"
              className='profil-card__picture-img'
            />
          </div>
          <div className='profil-card__picture-info'>
            <h5 className='profil-card__picture-title'>Bine ai venit, {userData?.username || username}! 👋</h5>
          <p className='profil-card__picture-description'>Ne bucuram sa te avem pe ContaLearn.</p>
          </div>
        </div>
      </div>
      <form className='profil-card__form' onSubmit={onProfileSave}>
        <div className='profil-card__form-group'>
          <label className='profil-card__form-label'>
            Nume utilizator <FontAwesomeIcon icon={faPen} style={{ fontSize: '11px', color: '#16c79e', marginLeft: '6px' }} />
          </label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              className='profil-card__form-input'
              value={username !== undefined ? username : (userData?.username || '')}
              onChange={e => onUsernameChange && onUsernameChange(e.target.value)}
              placeholder="Introdu numele tau"
              style={{ paddingRight: '36px' }}
            />
            <FontAwesomeIcon
              icon={faPen}
              style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#b0b0b0', fontSize: '13px', pointerEvents: 'none' }}
            />
          </div>
        </div>
        <div className='profil-card__form-group'>
          <label className='profil-card__form-label'>Adresa de email</label>
          <input
            type="email"
            className='profil-card__form-input'
            value={userData?.email || ''}
            placeholder="email@example.com"
            disabled
          />
          <small className='profil-card__form-hint'>Email-ul nu poate fi modificat</small>
        </div>
        <button type="submit" className='profil-card__btn-save-profile'>
          <span>Salveaza modificarile</span>
        </button>
      </form>
    </div>
  );
};

export default ProfilCard;
